import React, { useEffect, useState, useRef } from 'react'
import Matter from 'matter-js'
import ping from '../../sounds/Ping-2.mp3';

// inspired by https://paulie.dev/posts/2020/08/react-hooks-and-matter-js/

const STATIC_DENSITY = 15
let PARTICLE_SIZE = 70
const PARTICLE_BOUNCYNESS = 0.9

const ShapesDropping = ({ sides, color, theme, removeShapes }) => {

  const boxRef = useRef(null)

  const [constraints, setContraints] = useState()
  const [scene, setScene] = useState()
  const [dropShapes, setDropShapes] = useState(true)
  let numberOfBalls = 0;

  const handleResize = () => {
    setContraints(boxRef.current.getBoundingClientRect())
    // because setContraints is a react State,
    // the above line causes the dropShape interval to re-render,
    // releasing another set of balls.
    // After trying various things, settled on this solution:
    setDropShapes(false);
  }

  useEffect(() => {

    let colorHex = '#FFFFFF';
    switch(color) {
      case '0':
        colorHex = theme.pageStyle1.hint1; break;
      case '1':
        colorHex = theme.pageStyle2.hint1; break;
      case '2':
        colorHex = theme.pageStyle1.hint2; break;
      case '3':
        colorHex = theme.pageStyle2.hint2; break;
      default:
        colorHex = '#5C5C5C'; break;
    }

    if (scene) {
      let { width } = constraints
      let randomX = Math.floor(Math.random() * -width) + width

      if (width < 650) {
        PARTICLE_SIZE = width/10
      }

      Matter.World.add(
        scene.engine.world,
        // Ref: https://brm.io/matter-js/docs/classes/Bodies.html
        Matter.Bodies.polygon(randomX, -PARTICLE_SIZE, 2 + parseFloat(sides), PARTICLE_SIZE, {
          restitution: PARTICLE_BOUNCYNESS,
          render: {
            fillStyle: colorHex,
          }
        }),
      )
    }

  }, [sides, color])

  useEffect(() => {
    let Engine = Matter.Engine
    let Render = Matter.Render
    let World = Matter.World
    let Bodies = Matter.Bodies
    let Events = Matter.Events

    let engine = Engine.create({})

    let render = Render.create({
      element: boxRef.current,
      engine: engine,
      //canvas: canvasRef.current,
      options: {
        background: 'transparent',
        wireframes: false,
      },
    })

    const floor = Bodies.rectangle(0, 0, 0, STATIC_DENSITY, {
      isStatic: true,
      render: {
        fillStyle: 'blue',
      },
    });
    World.add(engine.world, [floor])

    const fakeBtn = Bodies.rectangle(0, 0, 680, 75, {
      isStatic: true,
      render: {
        fillStyle: '#ffffff',
        opacity: 0.03
      },
    });
    World.add(engine.world, [fakeBtn])

    Matter.Runner.run(engine)
    Render.run(render)

    setContraints(boxRef.current.getBoundingClientRect())
    setScene(render)

    Events.on(engine, 'collisionStart', function (event) {
      for (var i = 0; i < event.pairs.length; i++) {
        var pair = event.pairs[i];
        if (pair.collision.collided) {
          let audio = new Audio(ping);
          audio.volume = 0.75;
          audio.play();
        }
      }
    });

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    if (scene) {
      Matter.World.clear(scene.engine.world);
    }
  }, [removeShapes])

  useEffect(() => {
    if (constraints) {
      let { width, height } = constraints

      // SR - height set above, is only the Window
      // in case the page scrolls, we need the full body height
      height = document.body.scrollHeight;

      // Dynamically update canvas and bounds
      scene.bounds.max.x = width
      scene.bounds.max.y = height
      scene.options.width = width
      scene.options.height = height
      scene.canvas.width = width
      scene.canvas.height = height

      // Dynamically update floor
      const floor = scene.engine.world.bodies[0]

      Matter.Body.setPosition(floor, {
        x: width / 2,
        y: height + STATIC_DENSITY / 2,
      })

      Matter.Body.setVertices(floor, [
        { x: 0, y: height },
        { x: width, y: height },
        { x: width, y: height + STATIC_DENSITY },
        { x: 0, y: height + STATIC_DENSITY },
      ])

      // Dynamically update fake button
      const fakeBtn = scene.engine.world.bodies[1]
      let btnOffset = (width<768)?62:127;

      Matter.Body.setPosition(fakeBtn, {
        x: width / 2.02,
        y: height - btnOffset,
      })

    }

  }, [scene, constraints])


  return (
    <div ref={boxRef} className="w-screen h-screen absolute top-0 left-0 pointer-events-none"></div>
  )
}

export default ShapesDropping;
